// Minimal utilities for early config loading in APILoader

// Check if DDC data structures are ready with retry logic
export const hasDataLayer = (timeout = 2000) => {
	return new Promise((resolve, reject) => {
		// Check immediately first
		const checkDataLayer = () => {
			return (
				window.DDC &&
				window.DDC.dataLayer &&
				Object.keys(window.DDC.dataLayer).length &&
				window.DDC.siteSettings &&
				Object.keys(window.DDC.siteSettings).length
			);
		};

		if (checkDataLayer()) {
			resolve(true);
			return;
		}

		let checkInterval;
		const timeoutId = setTimeout(() => {
			if (checkInterval) {
				clearInterval(checkInterval);
			}
			reject(new Error("I can't find this"));
		}, timeout);

		// Check every 50ms
		checkInterval = setInterval(() => {
			if (checkDataLayer()) {
				clearTimeout(timeoutId);
				clearInterval(checkInterval);
				resolve(true);
			}
		}, 50);
	});
};

// Minimal URL params parser
const getUrlParams = () => {
	const params = {};
	const queryString = window.location.search.substring(1);
	const pairs = queryString.split('&');

	pairs.forEach(pair => {
		const [key, value] = pair.split('=');
		if (key) {
			params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
		}
	});

	return params;
};

// Extract page metadata (minimal version)
const getPageMetaData = async () => {
	await hasDataLayer();

	const { pageInfo, attributes } = window.DDC.dataLayer.page;
	const { siteSettings } = window.DDC;

	return {
		siteId: siteSettings.siteId || '',
		pageName: pageInfo.pageName || '',
		layoutType: attributes.layoutType || '',
		locale: attributes.locale || ''
	};
};

// Simple fetch wrapper
const fetchJson = async url => {
	const response = await fetch(url);
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return response.json();
};

// Fetch configs - single implementation
export const loadConfigsEarly = async () => {
	const pageData = await getPageMetaData();
	const { layoutType, pageName, siteId, locale } = pageData;
	const uri = '/api/ipp/config/services';
	const integrationTypes = ['api', 'api_compatible'];
	const fetchParams = [
		`integrationType=${integrationTypes.join(',')}`,
		`deviceType=${layoutType}`,
		`pageAlias=${pageName}`,
		`siteId=${siteId}`,
		`locale=${locale}`
	];

	// Add cache breaking parameter if needed
	const urlParams = getUrlParams();
	if (
		urlParams._toggleBasePageCache === 'false' ||
		urlParams._toggleWIAPICache === 'false'
	) {
		fetchParams.push(`r=${new Date().getTime()}`);
	}

	return fetchJson(`${uri}?${fetchParams.join('&')}`);
};
